/* eslint-disable */
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map'

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import Permissions from '@/lib/permissions';
import { get3DUrl } from './show3DTarget';

// MUI
import PublicIcon from '@mui/icons-material/Public';
import LaunchIcon from '@mui/icons-material/Launch';
import UserContext, { UserContextType } from '@/context/UserContext/UserContext';
import { Box, ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';

const Show3DButtonListItem = (props: TCustomGFIActionProps) => {

    const { t } = useTranslation();

    const userContext = useContext(UserContext) as UserContextType;

    const { featureData, handleCloseMenu } = props;

    const handleShow3D = () => {
        window.open(get3DUrl(featureData), '_blank');
    };

    const handleClick = () => {
        handleShow3D();
        if (handleCloseMenu) {
            handleCloseMenu();
        }
    }

    return  !userContext.hasAnyPermission([Permissions.ThreeDView]) ? null : (
        <MenuItem
            onClick={handleClick}
            sx={{minHeight: "36px"}}
        >
            <ListItemIcon>
                <PublicIcon color='primary' fontSize='small'/>
            </ListItemIcon>
            <ListItemText>
                {t('buttons.show_3d')}
            </ListItemText>
            <LaunchIcon sx={{ml:1}} color='disabled' fontSize='small'/>
        </MenuItem>
    )
}

export default Show3DButtonListItem;